import { DictionaryRiverSideAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionaryRiverSides() {
  return useAutocompleteSource<DictionaryRiverSideAutocomplete>({
    url: EvidenceAPI.DICTIONARY_RIVER_SIDES + '/autocomplete',
  });
}
